import { render } from "./ParametersSection.vue?vue&type=template&id=988118fe&scoped=true&ts=true"
import script from "./ParametersSection.vue?vue&type=script&lang=ts"
export * from "./ParametersSection.vue?vue&type=script&lang=ts"

import "./ParametersSection.vue?vue&type=style&index=0&id=988118fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988118fe"]])

export default __exports__